import { KeyValue } from "@angular/common";

export class ExportRequest {
    ContentType!: ContentTypeEnum;
    FormatType!: FormatTypeEnum;
    SearchCriteria!: any;
    Filters!: any;
}

export enum ContentTypeEnum {
    Document = 0,
    TrainingPlanReview = 1,
    TrainingStatus = 2
}

export enum FormatTypeEnum {
    pdf = 0,
    excel = 1,
    word = 2
}